export const editorUrl = "https://cdn.ckeditor.com/4.18.0/full-all/ckeditor.js";
